import {carStates} from '../cars-routes';

export default function CarsSearchFormController(
    $scope,
    $rootScope,
    $state,
    carsFactory
) {
    'ngInject';

            const formats = carsFactory.formats;

            $scope.typeaheadHelpers = {
                pickUpQuery: '',
                dropOffQuery: '',
            };

            $scope.carsRequestData = carsFactory.carsRequestData;

            $scope.pickUpDateSettings = angular.copy($scope.carsRequestData.pickUp.date.pickerSettings);
            $scope.dropOffDateSettings = angular.copy($scope.carsRequestData.dropOff.date.pickerSettings);

            $scope.requestDefaults = {
                Radius: 20,
                IsUserAgeOutOfRange: false,
                Min: 0,
                Max: 20,
                PickUpAddress: '',
                DropOffAddress: '',
            };

            $scope.$watchCollection(() => [$scope.carsRequestData.pickUp.date.value, $scope.carsRequestData.dropOff.date.value], () => {
                $scope.carsRequestData.adjustDates({});
            });

            init();

            function init() {
                getTopPreviousSearches();
                getPopularPickUpLocations();
            }

            $scope.scrollToSelected = function(scrolledFlag, $event) {
                const options = $scope.carsRequestData[scrolledFlag].time.options;
                const current = $scope.carsRequestData[scrolledFlag].time.current;
                const target = angular.element($event.target).find('.dropdown').length
                        ? angular.element($event.target).find('.dropdown')
                        : angular.element($event.target).siblings('.dropdown');
                const optionHeight = target.children().first().height();
                const index = _.findIndex(options, function(option) {
                        return option.value === current.value;
                    });

                target.scrollTop((index) * optionHeight);
            };

            $scope.dropOffSameAsPickUp
                = $scope.carsRequestData.pickUp.location.address === $scope.carsRequestData.dropOff.location.address;

            $scope.recentLocations = {
                pickUpUpdated: false,
                dropOffUpdated: false,
                pickUp: [],
                dropOff: [],
                prevPickUpAddress: null,
            };

            $scope.getCaption = function(res) {
                return res.LocationName;
            };

            $scope.dropOffSameChanged = function() {
                $scope.carsRequestData.dropOff.clearLocation();
            };

            $scope.getPopularDropOffLocations = function() {
                const pickUpAddress = $scope.carsRequestData.pickUp.location.address;
                const pickUpLongitude = pickUpAddress && $scope.carsRequestData.pickUp.location.longitude;
                const pickUpLatitude = pickUpAddress && $scope.carsRequestData.pickUp.location.latitude;

                if (pickUpAddress !== $scope.recentLocations.prevPickUpAddress) {
                    $scope.recentLocations.dropOffUpdated = false;
                    $scope.recentLocations.dropOff = [];
                    $scope.recentLocations.prevPickUpAddress = pickUpAddress;
                }

                if ($scope.recentLocations.dropOffUpdated) {
                    return;
                }

                carsFactory.getPopularLocations(pickUpLongitude, pickUpLatitude)
                    .then(({data}) => {
                        $scope.recentLocations.dropOff = data.DropOffLocations;
                        $scope.recentLocations.dropOffUpdated = true;
                    });
            };

            $scope.setPickUp = function(pickUpViewModel) {
                return function(location) {
                    pickUpViewModel.$setValidity('editable', true);

                    $scope.carsRequestData.pickUp.location.address = location.LocationName;
                    $scope.carsRequestData.pickUp.location.altAddress = location.LocationName;
                    $scope.carsRequestData.pickUp.location.longitude = location.Longitude;
                    $scope.carsRequestData.pickUp.location.latitude = location.Latitude;
                    $scope.carsRequestData.pickUp.location.isAirport = location.IsPickupLocationAirport;
                };
            };

            $scope.setDropOff = function(dropOffViewModel) {
                return function(location) {
                    dropOffViewModel.$setValidity('editable', true);

                    $scope.carsRequestData.dropOff.location.address = location.LocationName;
                    $scope.carsRequestData.dropOff.location.altAddress = location.LocationName;
                    $scope.carsRequestData.dropOff.location.longitude = location.Longitude;
                    $scope.carsRequestData.dropOff.location.latitude = location.Latitude;
                    $scope.carsRequestData.dropOff.location.latitude = location.IsDropOffLocationAirport;
                };
            };

            $scope.setPickUpTime = function(val) {
                $scope.carsRequestData.adjustDates({pickUpTime: val});
                const timeOptsAmount = $scope.carsRequestData.defaultTimeOptions.length - 1;
                $scope.pickUpDateSettings.shiftDependentDays = Number(
                    val.value === $scope.carsRequestData.defaultTimeOptions[timeOptsAmount].value
                );
            };

            $scope.setDropOffTime = function(val) {
                $scope.carsRequestData.adjustDates({dropOffTime: val});
            };

            function getTopPreviousSearches() {
                carsFactory.getTopPreviousSearches()
                    .then(({data}) => $scope.previousSearches = data);
            }

            function getAllPreviousSearches() {
                carsFactory.getAllPreviousSearches()
                    .then(({data}) => $scope.previousSearches = data);
            }

            $scope.customPreviousSearches = true;

            $scope.togglePreviousSearches = function() {
                $scope.customPreviousSearches = $scope.customPreviousSearches === false;
                if ($scope.customPreviousSearches) {
                    getTopPreviousSearches();
                } else {
                    getAllPreviousSearches();
                }
            };

            $scope.repeatSearch = function(search, carsRequestData, requestDefaults) {
                if (!moment(search.PickUpDate).isAfter(moment())) {
                    getTopPreviousSearches();
                    return;
                }
                $scope.dropOffSameAsPickUp = search.PickUpAddress === search.DropOffAddress;
                // Wrap in timeout otherwise dropOff address is set to undefined
                carsRequestData.pickUp.location.address = search.PickUpAddress;
                carsRequestData.pickUp.location.latitude = search.PickUpLatitude;
                carsRequestData.pickUp.location.longitude = search.PickUpLongitude;
                carsRequestData.pickUp.location.isAirport = search.IsPickupLocationAirport;
                carsRequestData.pickUp.location.altAddress = search.PickUpAddress;
                carsRequestData.pickUp.setDateTime(search.PickUpDate, true);

                carsRequestData.dropOff.location.address = search.DropOffAddress;
                carsRequestData.dropOff.location.latitude = search.DropOffLatitude;
                carsRequestData.dropOff.location.longitude = search.DropOffLongitude;
                carsRequestData.dropOff.location.isAirport = search.IsDropOffLocationAirport;
                carsRequestData.dropOff.location.altAddress = search.DropOffAddress;
                carsRequestData.dropOff.setDateTime(search.DropOffDate, true);
                carsRequestData.isUserOutOfRange = !!(search.IsUserAgeOutOfRange);

                $scope.findCars(carsRequestData, requestDefaults, $scope.dropOffSameAsPickUp);
            };

            $scope.findCars = function(carsReq, requestDefaults, dropOffSameAsPickUp) {
                $scope.recentLocations.pickUpUpdated = false;
                $scope.recentLocations.dropOffUpdated = false;

                if (dropOffSameAsPickUp) {
                    carsReq.dropOff.location = angular.copy(carsReq.pickUp.location);
                }

                const requestParams = {
                    Radius: carsReq.Radius || requestDefaults.Radius,
                    PickUpLatitude: carsReq.pickUp.location.latitude,
                    PickUpLongitude: carsReq.pickUp.location.longitude,
                    IsPickupLocationAirport: carsReq.pickUp.location.isAirport,
                    PickUpAddress: carsReq.pickUp.location.altAddress,
                    DropOffLatitude: carsReq.dropOff.location.latitude,
                    DropOffLongitude: carsReq.dropOff.location.longitude,
                    IsDropOffLocationAirport: carsReq.dropOff.location.isAirport,
                    DropOffAddress: carsReq.dropOff.location.altAddress,
                    IsUserAgeOutOfRange: carsReq.isUserOutOfRange,
                    PickUpDate: carsReq.pickUp.getDateTime().format(formats.dateTime),
                    DropOffDate: carsReq.dropOff.getDateTime().format(formats.dateTime),
                    Min: requestDefaults.Min,
                    Max: requestDefaults.Max,
                    CarSorting: 2,
                };

                carsFactory.resetFilters();
                carsFactory.resetSearchId();

                $state.go(carStates.RESULTS, requestParams);
            };

            function getPopularPickUpLocations() {
                carsFactory.getPopularLocations()
                    .then(({data}) => {
                        const {PickUpLocations, DropOffLocations} = data;
                        $scope.recentLocations.pickUp = PickUpLocations;
                        $scope.recentLocations.dropOff = DropOffLocations;
                    });
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/controllers/cars-search-form-controller.js